module.exports = "<div class=\"container-fluid largeRow\">\n\t<ng-content></ng-content>\n</div>"